import tw from 'twin.macro';
import styled from '@emotion/styled';

export const CountDownTimer = styled.div`
  ${tw`text-center flex items-center w-auto h-5 text-red-1 whitespace-nowrap`}
`;
